import React from 'react';

const TitleMid = (props) => {
    return (
        <div className='fontMid' style={{ fontWeight: 500, color: '#212121' }}>
            {props.value}
        </div>
    );
}

export default TitleMid;